module.exports = __webpack_public_path__ + "static/media/001A_vmware_topics.a75e3219.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/vmware/001A_vmware_topics.png
// module id = 633
// module chunks = 0